import { createApiReducers, createApiReducerInitialState } from '../../Helpers/reducer'

import { GET_DESKTOP_PROPERTIES } from './desktopProperties.constants'

const initialState = {
  ...createApiReducerInitialState('desktopProperties', {}, true),
}

//We keep adding/overwriting the properties. This will be useful for future caching
export default (state = initialState, action) => {
  const reducers = {
    ...createApiReducers(GET_DESKTOP_PROPERTIES, 'desktopProperties', {}, false, (data, previousData) => ({
      ...previousData,
      ...data,
    })),
    //No reducer needed for put desktop properties
  }

  return reducers[action.type] ? reducers[action.type](state, action) : state
}
